/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_DeletingInputs */

const en_settings_apikeys_deleting = /** @type {(inputs: Settings_Apikeys_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting...`)
};

/**
* | output |
* | --- |
* | "Deleting..." |
*
* @param {Settings_Apikeys_DeletingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_deleting = /** @type {((inputs?: Settings_Apikeys_DeletingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_DeletingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_deleting(inputs)
});
export { settings_apikeys_deleting as "settings.apikeys.deleting" }